import { Button } from "@lya-protect/lya-protect-form-library/dist/UI";
import { InfoCard } from "@src/components/infoCard/InfoCard";
import { LinkButton } from "@src/components/linkButton/LinkButton";
import { NavButton } from "@src/components/navButton/NavButton";
import { OffreCardDownload } from "@src/components/offreCard/OffreCard";
import { _Activity } from "@src/Steps/simulate/activities/Activities";
import { formatCurrency } from "@src/utils";
import { ReactComponent as Check } from "@src/svg/check.svg";
import { SimulationPrestationsCollapse } from "@src/Steps/simulate/tarif/components/SimulationPrestationsCollapse";
import { StepName } from "../../step/Steps";
import { Tarif } from "./Tarif";
import "./tarifMobile.scss";

type TableCellProps = {
  title: JSX.Element;
  desc?: JSX.Element;
  content: JSX.Element[];
  actions?: (JSX.Element | undefined)[];
  shiftedContent?: boolean;
};
function TableCell({
  content,
  desc,
  title,
  shiftedContent,
  actions,
}: TableCellProps) {
  return (
    <div className="tarif-mobile-step__table-cell">
      <div className="tarif-mobile-step__table-cell-title">{title}</div>
      <div className="tarif-mobile-step__table-cell-desc">{desc}</div>
      <div
        className="tarif-mobile-step__table-cell-content"
        data-shifted={shiftedContent}
      >
        {content.map((item, index) => (
          <div
            key={index} //eslint-disable-line
            className="tarif-mobile-step__table-cell-item"
          >
            {item}
          </div>
        ))}
      </div>
      {actions && (
        <div className="tarif-mobile-step__table-cell-actions">
          {actions.map((action, index) => (
            <div
              key={index} //eslint-disable-line
              className="tarif-mobile-step__table-cell-action"
            >
              {action || null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Included() {
  return (
    <p className="tarif-mobile-step__included">
      <Check className="tarif-mobile-step__included-svg" /> Inclus
    </p>
  );
}

type TarifMobileProps = {
  tarifs: Tarif[];
  openModalGassistance: () => void;
  selectTarif: (tarif: Tarif) => () => void;
  changeStep: (
    stepName: StepName,
    transitionDirection: "forward" | "backward"
  ) => void;
  visibleActivities: _Activity[];
};
export function TarifMobile({
  changeStep,
  openModalGassistance,
  selectTarif,
  tarifs,
  visibleActivities,
}: TarifMobileProps) {
  return (
    <div className="tarif-mobile-step">
      <div className="stepper__centered-container">
        <div className="stepper__centered-content step__grid step__grid--padding-bottom">
          <NavButton
            onClick={() => {
              changeStep("ACTIVITIES", "backward");
            }}
          >
            Précédent
          </NavButton>
          <div className="tarif-mobile-step__header">
            <h1>Choisissez votre niveau d&apos;indemnisation</h1>
          </div>
          <div>
            <div className="tarif-mobile-step__table-header">
              {tarifs.map((tarif, index) => (
                <div
                  key={index} // eslint-disable-line
                  className="tarif-mobile-step__table-header-item"
                >
                  {tarif.name}
                </div>
              ))}
            </div>
            <TableCell
              title={
                <h2>
                  Garantie séquelles physiques et psychiques faisant suite à un
                  accident de la vie courante
                </h2>
              }
              desc={<p>Indemnisation dès 1% d'AIPP</p>}
              content={[
                <p>500 € par % d&apos;AIPP</p>,
                <p>1 000 € par % d&apos;AIPP</p>,
                <p>1 500 € par % d&apos;AIPP</p>,
              ]}
            />
            <TableCell
              title={<h2>Garantie décès accidentel</h2>}
              desc={<p>Décès accidentel jusqu’à l’âge de 67 ans au plus</p>}
              content={[<p>60 000 €</p>, <p>120 000 €</p>, <p>180 000 €</p>]}
            />

            <TableCell
              shiftedContent
              title={
                <h2>
                  Garanties assistance <br /> 24h/24 - 7j/7
                </h2>
              }
              desc={
                <LinkButton onClick={openModalGassistance}>
                  Détail des garanties
                </LinkButton>
              }
              content={[<Included />, <Included />, <Included />]}
            />
            <TableCell
              title={<h2>Montant de la cotisation</h2>}
              desc={
                <p>
                  2 mois offerts pour toute souscription jusqu&apos;au
                  31/12/2026 *
                </p>
              }
              content={[
                <div className="tarif-mobile-step__simulation">
                  <p>
                    <b>{formatCurrency(tarifs[0].simulationCotisation)}</b>
                  </p>
                  <p>
                    {formatCurrency(tarifs[0].simulationCotisation * 12)} / an
                  </p>
                </div>,
                <div className="tarif-mobile-step__simulation">
                  <p>
                    <b>{formatCurrency(tarifs[1].simulationCotisation)}</b>{" "}
                  </p>
                  <p>
                    {formatCurrency(tarifs[1].simulationCotisation * 12)} / an
                  </p>
                </div>,
                <div className="tarif-mobile-step__simulation">
                  <p>
                    <b>{formatCurrency(tarifs[2].simulationCotisation)}</b>{" "}
                  </p>
                  <p>
                    {formatCurrency(tarifs[2].simulationCotisation * 12)} / an
                  </p>
                </div>,
              ]}
              actions={[
                tarifs[0].simulationCotisation !== null ? (
                  <Button
                    className="tarif-mobile-step__button"
                    onClick={selectTarif(tarifs[0])}
                  >
                    Choisir
                  </Button>
                ) : undefined,
                tarifs[1].simulationCotisation !== null ? (
                  <Button
                    className="tarif-mobile-step__button"
                    onClick={selectTarif(tarifs[1])}
                  >
                    Choisir
                  </Button>
                ) : undefined,
                tarifs[2].simulationCotisation !== null ? (
                  <Button
                    className="tarif-mobile-step__button"
                    onClick={selectTarif(tarifs[2])}
                  >
                    Choisir
                  </Button>
                ) : undefined,
              ]}
            />
          </div>
          <OffreCardDownload />
          <div className="tarif-mobile-step__info">
            <p>
              Le tableau des garanties et des tarifs ne comprend pas la liste
              des exclusions générales et des exclusions propres à chacune des
              garanties. Se référer au Règlement du contrat Paxivie.
            </p>
            <p>
              Les tarifs en vigueurs sont valables jusqu&apos;au{" "}
              <b>30/11/2026</b>, sous réserve de toute évolution.
            </p>
            <p>
              *Deux mois de cotisation offerts pour toute nouvelle souscription
              d&apos;un contrat Paxivie jusqu&apos;au 31 décembre 2026. Le
              montant de ces cotisations ne sera pas prélevé sur votre compte
              bancaire au titre du paiement de votre contrat. Offre non
              cumulable avec toute autre offre en cours sur le contrat Paxivie.
            </p>
          </div>
          {visibleActivities.length > 0 && (
            <SimulationPrestationsCollapse
              visibleActivities={visibleActivities}
              headerClassName="tarif-desktop-step__header"
            />
          )}
        </div>
      </div>
    </div>
  );
}
